import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptAnnouncementAnalytics } from "../adapters/adaptAnnouncements";

const fetchAnnouncementAnalytics = async (
	id: number
): Promise<IAnnouncementAnalytics> => {
	const response = await cmsClient.get<IAnnouncementAnalytics>(
		`/announcements/${id}/analytics/`
	);
	return response.data;
};

const useAnnouncementAnalytics = (id: number, enabled = true) => {
	const query = useQuery(
		["announcement-analytics", id],
		() => fetchAnnouncementAnalytics(id),
		{
			enabled: enabled && id > 0,
			select: adaptAnnouncementAnalytics
		}
	);
	return query;
};

export default useAnnouncementAnalytics;
